import React from 'react';

import RecordAction from '../PostAction/PostAction';

import { postActionPopups } from '../../../../helpers/constants';

import amDelete from '../../../../../../assets/img/accountmanagement/am-delete.svg';
import amEdit from '../../../../../../assets/img/accountmanagement/am-edit.svg';

import styles from './ImpactPostsListRecord.module.css';
import { SURVEY_LANGUAGES } from '../../../../../../surveys/components/SurveyBuilderPage/SurveyBuilder/helpers/constants';
import dutchFlag from '../../../../../../campaigns/components/CampaignTable/CampaignListItem/assets/dutch.png';
import frenchFlag from '../../../../../../campaigns/components/CampaignTable/CampaignListItem/assets/french.png';
import formatDateForAcquisitionDate from '../../../../../AcquisitionMetrics/helpers/formatDateForAcquisitionDate';

export default ({ post, setActivePopup }) => {
  const dutchDetailsPost =
    post &&
    post.content &&
    post.content.length &&
    post.content.find(c => c.language === SURVEY_LANGUAGES.DUTCH);
  const frenchDetailsPost =
    post &&
    post.content &&
    post.content.length &&
    post.content.find(c => c.language === SURVEY_LANGUAGES.FRENCH);

  return (
    <tr className={styles.record}>
      <td className={styles.rowContainer}>
        <div className={styles.multiLinesRowContainer}>
          {dutchDetailsPost ? (
            <div
              className={`${styles.nameContainer} ${
                !dutchDetailsPost.visible ? styles.notVisible : null
              }`}
            >
              <div className={styles.flagsContainer}>
                <img src={dutchFlag} alt="dutch language flag" />
              </div>
              {dutchDetailsPost.title}
            </div>
          ) : null}
          {frenchDetailsPost ? (
            <div
              className={`${styles.nameContainer} ${
                !frenchDetailsPost.visible ? styles.notVisible : null
              }`}
            >
              <div className={styles.flagsContainer}>
                <img src={frenchFlag} alt="french language flag" />
              </div>
              {frenchDetailsPost.title}
            </div>
          ) : null}
        </div>
      </td>
      <td className={styles.rowContainer}>
        <div className={styles.multiLinesRowContainer}>
          {dutchDetailsPost ? (
            <div className={styles.nameContainer}>
              {dutchDetailsPost.postDate
                ? formatDateForAcquisitionDate(
                    new Date(dutchDetailsPost.postDate)
                  )
                : ''}
            </div>
          ) : null}
          {frenchDetailsPost ? (
            <div className={styles.nameContainer}>
              {frenchDetailsPost.postDate
                ? formatDateForAcquisitionDate(
                    new Date(frenchDetailsPost.postDate)
                  )
                : ''}
            </div>
          ) : null}
        </div>
      </td>
      <td className={styles.rowContainer}>
        <div className={styles.actionButtonsContainer}>
          <>
            <RecordAction
              label="Edit"
              icon={amEdit}
              onClick={() => {
                setActivePopup({
                  type: postActionPopups.EDIT,
                  post: {
                    ...post
                  }
                });
              }}
            />
            <RecordAction
              label="Delete"
              icon={amDelete}
              onClick={() => {
                setActivePopup({ type: postActionPopups.DELETE, post });
              }}
            />
          </>
        </div>
      </td>
    </tr>
  );
};
